module.exports = __webpack_public_path__ + "static/media/jack_heart.511bfc53.png";